import React from 'react';
import sIcon1 from '../../images/icon/eye-icon.svg';
import sIcon2 from '../../images/feature/ap-feature01.jpg';
import sIcon3 from '../../images/feature/ap-feature02.jpg';
import sIcon4 from '../../images/feature/ap-feature03.jpg';

const features = [
    {
        id: 1,
        image: sIcon2,
        title: "We build solutions, not just software",
        description: "Our focus is on delivering scalable, efficient, and innovative software that drives business success."
    },
    {
        id: 2,
        image: sIcon3,
        title: "Reliable & Responsive Support",
        description: "If something goes wrong, we act fast. Our team ensures quick fixes and continuous improvements."
    },
    {
        id: 3,
        image: sIcon4,
        title: "Innovative Technology & Custom Solutions",
        description: "We develop proprietary tools and frameworks to bridge gaps and give your business a competitive edge."
    }
];

const WhyChoose = () => {
    return (
        <section className="feature pt-130">
            <div className="container">
                <div className="sec-title--two text-center mb-60">
                    <div className="sub-title"><img src={sIcon1} alt="Why Choose Us" /> Why Choose Us</div>
                    <h2 className="title">Customer-Centric Approach</h2>
                </div>
                <div className="row mt-none-30">
                    {features.map((feature) => (
                        <div className="col-lg-4 col-md-6 mt-30" key={feature.id}>
                            <div className="ap-fea-item pos-rel">
                                <div className="xb-item--img">
                                    <img src={feature.image} alt={feature.title} />
                                </div>
                                <h3 className="xb-item--content">{feature.title}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default WhyChoose;
